import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, Action } from 'redux'
import { IApplicationState } from '@Site/rootReducer'
import Popup from '@SiteComponents/Popup'
import Button from '@SiteComponents/Button'

import {
  deleteProjects,
} from '@SiteModules/Project/actions'

import {
  deleteProjectVersions,
} from '@SiteModules/ProjectVersion/actions'

import {
  closeDashboardPopups,
} from '@SiteModules/Popup/actions'

import {
  IDeleteProjectsPayload
} from '@SiteModules/Project/types'

import {
  IDeleteProjectVersionsPayload,
} from '@SiteModules/ProjectVersion/types'

import AttentionIcon from '@Images/attention.svg'

import './DeleteProjectPopup.scss'

interface DeleteProjectPopupProps {
  readonly isForProjectVersions: boolean
  readonly deleting: boolean
  readonly projectIds: string[]
  readonly projectVersionIds: string[]
  deleteProjects(payload: IDeleteProjectsPayload): void
  deleteProjectVersions(payload: IDeleteProjectVersionsPayload): void
  closeDashboardPopups(): void
}

interface DeleteProjectState {
  readonly deleteConfirmation: string
}

class DeleteProjectPopup extends React.Component<DeleteProjectPopupProps, DeleteProjectState> {
  state = {
    deleteConfirmation: ''
  }

  changeDeleteCofirmation = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      deleteConfirmation: (e.target as HTMLInputElement).value
    })
  }

  handleConfirm = () => {
    const canDelete = this.state.deleteConfirmation === 'delete' || this.state.deleteConfirmation === 'DELETE'

    if (canDelete) {
      this.props.isForProjectVersions ? this.props.deleteProjectVersions({ projectVersionIds: this.props.projectVersionIds }) : this.props.deleteProjects({ projectIds: this.props.projectIds, notifyAboutSuccess: true })
      this.props.closeDashboardPopups()
    }
  }

  render() {
    const { deleting } = this.props
    const { deleteConfirmation } = this.state
    const canDelete = this.state.deleteConfirmation === 'delete' || this.state.deleteConfirmation === 'DELETE'
    const shouldDisableButton = !canDelete || deleting
    const entities = this.props.isForProjectVersions ? 'clip(s)' : 'project(s)'

    return (
      <Popup
        className="DeleteProjectPopup"
        closePopup={this.props.closeDashboardPopups}
        zIndex={200000}
      >
        <div className="DeleteProjectPopup__title">{`Delete the ${entities}`}</div>
        <p className="DeleteProjectPopup__description">
          <AttentionIcon className="DeleteProjectPopup__description__icon" />
          {`Warning, you will delete the ${entities}`}<br />
          and all the subtitles related to them.
        </p>
        <p className="DeleteProjectPopup__description">
          Type “delete” below to validate this action.
        </p>

        <input className="DeleteProjectPopup__confirmation"
          placeholder="delete"
          value={deleteConfirmation}
          onChange={this.changeDeleteCofirmation}
        />

        <Button
          styleType="brand"
          size="large"
          caption="Confirm the action"
          onClick={this.handleConfirm}
          disabled={shouldDisableButton}
        />
      </Popup>
    )
  }
}

function mapStateToProps(state: IApplicationState) {
  const { popup, projects } = state

  return {
    deleting: projects.deleting,
    projectIds: popup.editingProjectIds,
    projectVersionIds: popup.editingProjectVersionIds,
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action>) {
  return bindActionCreators({
    deleteProjects,
    deleteProjectVersions,
    closeDashboardPopups,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteProjectPopup)
